/*eslint camelcase: off*/
import isUndefined from 'lodash/isUndefined';
export var includes = function includes(arr, value) {
  return Boolean(arr && arr.find(function (item) {
    return item === value;
  })); // we compare only primitives
};

export function google2address(google) {
  var components = {};
  google.address_components.forEach(function (_ref) {
    var types = _ref.types,
        long_name = _ref.long_name,
        short_name = _ref.short_name;

    types.forEach(function (type) {
      components[type] = { long_name: long_name, short_name: short_name };
    });
  });

  var locality = components.locality || components.sublocality || components.postal_town;
  var result = {
    formatted: google.formatted_address,
    latLng: {
      lat: google.geometry.location.lat(),
      lng: google.geometry.location.lng()
    },
    approximate: !includes(google.types, 'street_address') && !includes(google.types, 'premise'),
    city: locality && locality.long_name,
    state: components.administrative_area_level_1 && components.administrative_area_level_1.short_name,
    country: components.country && components.country.long_name,
    countryCode: components.country && components.country.short_name,
    street: components.route && components.route.long_name,
    number: components.street_number && components.street_number.long_name,
    postalCode: components.postal_code && components.postal_code.long_name
  };

  for (var key in result) {
    if (isUndefined(result[key])) {
      delete result.key;
    }
  }

  return result;
}
//# sourceMappingURL=google2address.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/GoogleAddressInput/google2address.js